// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows-module__Arrows___8YL8x","show":"Arrows-module__show___wudfZ","hide":"Arrows-module__hide___Yujnp"};